import dom from "../dom";

const init = function () {
    document.querySelectorAll(".js-scrollTo").forEach((elem) => {
        const selector = elem.getAttribute("href");
        if (!selector) {
            return;
        }

        const elementForScroll = document.querySelector(selector);
        if (!elementForScroll) {
            return;
        }

        elem.addEventListener("click", (e) => {
            e.preventDefault();
            dom.scrollToElement(elementForScroll, 60);
        });
    });
};

export default {
    init: init,
};
